/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifactfirmmessagedescriptionv24Inputs */

const en_artifactfirmmessagedescriptionv24 = /** @type {(inputs: Artifactfirmmessagedescriptionv24Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The first formal letter Portuguese homeowners send before calling a lawyer. It opens a paper trail, shows the contractor you have your facts straight, and gives them a face-saving way to fix things. Most disputes resolve here — the few that don't, you escalate to the registered notice.`)
};

const pt_artifactfirmmessagedescriptionv24 = /** @type {(inputs: Artifactfirmmessagedescriptionv24Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A primeira carta formal que os proprietários portugueses enviam antes de recorrerem a um advogado. Abre um registo escrito, mostra ao empreiteiro que tem os factos organizados e dá-lhe uma forma honrosa de resolver. A maioria dos casos resolve-se nesta fase — para os que não resolvem, o passo seguinte é a interpelação admonitória.`)
};

/**
* | output |
* | --- |
* | "The first formal letter Portuguese homeowners send before calling a lawyer. It opens a paper trail, shows the contractor you have your facts straight, and gi..." |
*
* @param {Artifactfirmmessagedescriptionv24Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const artifactfirmmessagedescriptionv24 = /** @type {((inputs?: Artifactfirmmessagedescriptionv24Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifactfirmmessagedescriptionv24Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_artifactfirmmessagedescriptionv24(inputs)
	return pt_artifactfirmmessagedescriptionv24(inputs)
});
export { artifactfirmmessagedescriptionv24 as "artifactFirmMessageDescriptionV2" }